import type { AccessibilityProps } from 'react-native'
import { Icon, type TIconProps } from '~/components/icon'

interface TModalIconProps extends AccessibilityProps {
  symbol?: TIconProps['symbol']
  testID?: string
  color?: TIconProps['color']
}

export function ModalIcon({ symbol, testID, color }: TModalIconProps) {
  return <Icon size="small" testID={testID} symbol={symbol} color={color} />
}
